import { apiClient } from '@/services/base'
import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { IMultiTenantCreate2FARequest } from './interfaces/request'
import { IMultiTenantCreate2FAResponse } from './interfaces/response'

export const MultiTenantCreate2FAService = async (
  request: IMultiTenantCreate2FARequest,
): Promise<IMultiTenantCreate2FAResponse> => {
  const response = await apiClient.post(
    'api/Login/MultiTenantCreate2FA',
    request,
    {
      baseURL: process.env.NEXT_PUBLIC_API_BACKEND_URL,
    },
  )

  return response?.data
}

export const useMultiTenantCreate2FAService = (): UseMutationResult<
  IMultiTenantCreate2FAResponse,
  Error,
  IMultiTenantCreate2FARequest
> => {
  return useMutation<
    IMultiTenantCreate2FAResponse,
    Error,
    IMultiTenantCreate2FARequest
  >({
    mutationFn: async (request) => {
      const response = await apiClient.post(
        'api/Login/MultiTenantCreate2FA',
        request,
      )

      return response.data
    },
  })
}

export type { IMultiTenantCreate2FARequest, IMultiTenantCreate2FAResponse }
